import { GET_ONE_1BILL_MANNUAL_SETTLEMENT_REPORT, GET_SHOP_ORDER_TRANSACTION_DETAIL_BY_ID, GET_SHOP_ORDER_TRANSACTION_DETAIL_BY_PSID } from "../../Types";

const initialState = {
  OneBillTransactionsList: {},
  OnBillTransactionDetail:{},
  OnBillTransactionDetailById:{}
};

const OneBillManualSettlementReducer = (state = [], action) => {
  switch (action.type) {
    case GET_ONE_1BILL_MANNUAL_SETTLEMENT_REPORT:
      return { ...state, OneBillTransactionsList: action.payload, };      
    case GET_SHOP_ORDER_TRANSACTION_DETAIL_BY_PSID:
      return { ...state, OnBillTransactionDetail: action.payload, };  
    case GET_SHOP_ORDER_TRANSACTION_DETAIL_BY_ID:
      return { ...state, OnBillTransactionDetailById: action.payload, };    
    default:
      return state;
  }
};
export default OneBillManualSettlementReducer;
